const polyUtil = require('polyline-encoded');
export default function(route, map, color="#FFFF00", opacity=1.0, weight=2) {
    let lines = [];
    route.forEach(step => {
        const points = polyUtil.decode(step.polyline.points).map(group => { return {lat: group[0], lng: group[1]}});
        const line = new google.maps.Polyline({
            path: points,
            geodesic: true,
            strokeColor: color,
            strokeOpacity: opacity,
            strokeWeight: weight,
        });
        line.setMap(map);
        lines.push(line);

    })
    return lines;
}
